module.exports = __webpack_public_path__ + "static/img/m-spec-detail-velcro.99f60af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/switcher/m-spec-detail-velcro.png
// module id = eO7K
// module chunks = 1